import { ReactNode } from 'react'
import {
  TableBody,
  TableBodyRow,
  TableBodyRowTd,
  TableHeader,
  TableHeaderItem,
  TableListWrap,
} from './styles'
import InfiniteScroll from 'react-infinite-scroller'
import { NoData } from 'components/NoData'

interface IColum {
  title?: string
  titleRender?: () => ReactNode
  key: string
  render?: (row: any, rowIndex: number) => any
  RenderComponent?: any
  width?: string
}

interface IProps {
  columns: Array<IColum>
  dataSource: Array<{
    [key: string]: any
  }>
  mobileRowClick?: (row: any) => void
  onScrollEnd?: () => void
  hasMore?: boolean
  rowStyle?: (row: any) => any
  tableBodyStyle?: any
}

export const TableList = ({
  columns,
  dataSource,
  mobileRowClick,
  onScrollEnd,
  hasMore,
  rowStyle,
  tableBodyStyle = {},
}: IProps) => {
  return (
    <TableListWrap>
      <TableHeader>
        {columns?.length > 0 &&
          columns.map((item: IColum) => {
            const style = item.width ? { width: item.width } : { flex: 1 }
            return (
              <TableHeaderItem key={item.key} style={style}>
                {item?.titleRender ? item?.titleRender() : item.title}
              </TableHeaderItem>
            )
          })}
      </TableHeader>
      <TableBody id="zk_table_scroll_body" style={tableBodyStyle}>
        {dataSource?.length > 0 && (
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              if (typeof onScrollEnd === 'function' && hasMore) {
                onScrollEnd()
              }
            }}
            // loadMore={loadMoreItems}
            threshold={50}
            hasMore={hasMore}
            getScrollParent={() =>
              document.getElementById('zk_table_scroll_body')
            }
            useWindow={false}
          >
            {dataSource.length > 0 &&
              columns.length > 0 &&
              dataSource.map((row, rowIndex) => {
                const _rowStyle = rowStyle && rowStyle(row)
                return (
                  <TableBodyRow
                    key={`col-${rowIndex}`}
                    onClick={() => {
                      if (typeof mobileRowClick === 'function') {
                        mobileRowClick(row)
                      }
                    }}
                    style={_rowStyle}
                  >
                    {columns.map((col, colIndex) => {
                      const style = col.width
                        ? { width: col.width }
                        : { flex: 1 }
                      const { RenderComponent } = col
                      return (
                        <TableBodyRowTd
                          key={`col-${rowIndex}-${colIndex}`}
                          style={style}
                        >
                          {col?.render ? (
                            col.render(row, rowIndex)
                          ) : col?.RenderComponent ? (
                            <RenderComponent row={row} />
                          ) : (
                            row[col.key]
                          )}
                        </TableBodyRowTd>
                      )
                    })}
                  </TableBodyRow>
                )
              })}
          </InfiniteScroll>
        )}
        {dataSource?.length === 0 && <NoData />}
      </TableBody>
    </TableListWrap>
  )
}
